import { remove } from "lodash";

export const cart = {
  state: () => ({
    items: [],
    cartSummary: {},
    fees: [{ price: 0, type: "transport" }],
  }),
  mutations: {
    addProduct(state, {item, cartSummary}) {
      state.items.push(item);
      // state.cartSummary = cartSummary ?? {};
      Object.assign(state.cartSummary, cartSummary);
    },
    updateQty(state, {item, cartSummary}) {
      var sItem = state.items.find((itm) => itm._id === item._id);
      if (sItem) {
        Object.assign(sItem, item);
      }
      // state.cartSummary = cartSummary ?? {};
      Object.assign(state.cartSummary, cartSummary);
    },
    removeProduct(state, itemID) {
      remove(state.items, (item) => {
        return item._id === itemID;
      });
    },
    updateCartSummary(state, cartSummary) {
      Object.assign(state.cartSummary, cartSummary);

      const shipingFee = state.fees.find(f => f.type === 'transport');
      if (shipingFee) {
        shipingFee.price = cartSummary?.totSpedizione ?? 0;
      }
    },
    updateAllCartItems(state, cartItems) {
      // Build a Map from cartItems for fast lookup
      const cartMap = new Map(cartItems.map(item => [item._id, item]));

      // Update existing or mark for removal
      state.items = state.items.filter(item => {
        const updated = cartMap.get(item._id);
        if (updated) {
          Object.assign(item, updated); // Update state item
          cartMap.delete(item._id);     // Mark as synced
          return true; // Keep item in state
        }
        // Item not in cartItems, remove from state
        return false;
      });

      // Add remaining new items from cartItems to state
      for (const item of cartMap.values()) {
        state.items.push({ ...item });
      }
    },
    resetCart(state) {
      state.items = [];
      state.cartSummary = {};
      state.fees = [{ price: 0, type: "transport" }];
    },
  },
  actions: {
    addProduct({ commit, getters }, {item, cartSummary, priceOverride = -1}) {
      if (getters.productExistsInCart(item._id) !== undefined) {
        commit("updateQty", {item, cartSummary});
        return;
      }

      item.price = priceOverride === -1 ? item.prezzoUnitario : priceOverride;
      item.qty = item.qty ?? 1;

      commit("addProduct", {item, cartSummary});
    },
    removeProduct({ commit, getters }, id) {
      if (getters.productExistsInCart(id) !== undefined)
        commit("removeProduct", id);
    },
    updateCartSummary({ commit }, cartSummary) {
      commit("updateCartSummary", cartSummary);
    },
    updateAllCartItems({ commit }, cartItems) {
      commit("updateAllCartItems", cartItems);
    },
  },
  getters: {
    productExistsInCart: (state) => (id) => {
      return state.items.find((item) => item._id === id);
    },
    getSubtotal(state) {
      if (state.items.length === 1)
        return state.items[0].price * state.items[0].qty;

      return state.items.reduce((a, b) => a + b.price * b.qty, 0);
    },
    getSubtotalFees(state) {
      if (state.fees.length === 1) return state.fees[0].price;

      return state.fees.reduce((a, b) => a + b.price, 0);
    },
    getTotal(state, getters) {
      return getters.getSubtotal + getters.getSubtotalFees - (state.cartSummary.sconto ?? 0);
    },
    getFeeByType: (state) => (type) => {
      return state.fees.find((fee) => fee.type === type).price;
    },
    getTotalItems(state) {
      if (state.items.length === 1) return state.items[0].qty;
      return state.items.reduce((a, b) => a + b.qty, 0);
    },
  },
};
